<template>
  <div>
    <ListCardItem type="html-text" :text-content="_htmlText" />
    <ListCardItem
      title="姓名"
      type="text"
      row
      text-content="namename"
    />
    <ListCardItem title="信箱" type="text" row text-content="email" />
    <ListCardItem
      title="密碼"
      type="text-button"
      row
      text-content="•••••••••••••"
      button-text="變更密碼"
      @click="$_changePasswordClick()"
    />
  </div>
</template>

<script>
export default {
  computed: {
    _htmlText() {
      return `<ul data-type="todo_list"><li data-type="todo_item" data-done="true"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>a</p></div></li><li data-type="todo_item" data-done="false"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>b</p></div></li></ul>`;
    },
  }
}
</script>
